/* eslint-disable import/prefer-default-export */
import COLORS from '$variables/colors';

const looks = {
  default: {
    color: COLORS.grey3,
  },
  green: {
    color: COLORS.green,
  },
};

export { looks };
